import {createRouter, createWebHistory} from 'vue-router';
import {Capacitor} from '@capacitor/core';
import {store} from '@/store';
import {appRoutes} from './app';
import {publicRoutes} from './public';

const routes = [...appRoutes, ...publicRoutes];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
    },
});

const checkAuthGuard = () => {
    router.beforeEach(async (to, from, next) => {
        const isPublic = to.matched.some(record => record.meta.public);
        const isAuthenticated = store.getters['user/loggedIn'];
        const userLoaded = store.getters['user/userLoaded'];
        const isNativeApp = Capacitor.isNativePlatform();
        const secureFrontendInBrowsers = import.meta.env.VITE_LOCK_FRONTEND_IN_BROWSER;

        if (secureFrontendInBrowsers !== 'false' && !isNativeApp && !to.meta.allowInBrowser) {
            return next({ name: 'public.notAllowed' });
        }

        // ✅ Token exists but user hasn't been fetched yet, and you're not going to login
        if (isAuthenticated && !userLoaded && to.name !== 'public.login') {
            try {
                await store.dispatch('user/getUser');
            } catch (err) {
                store.commit('user/resetUserStore');
                localStorage.clear();
                return next({ name: 'public.login' });
            }
        }

        // 👤 Not public and not logged in? Force login
        if (!isPublic && !isAuthenticated) {
            return next({
                name: 'public.login',
                query: { redirect: to.fullPath },
            });
        }

        next();
    });
};



export {router, checkAuthGuard};
